import {
  PREFIX_CLASS
} from '@/utils/constants'

import Ctor from './constructor'
const PREFIXCLS = `${PREFIX_CLASS}tooltip`

export default {
  name: 'tooltip',
  bind(el, binding) {
    let ctor = new Ctor(
      Object.assign({}, binding.value, {
        prefixCls: PREFIXCLS
      })
    )
    let trigger = (binding.value && binding.value.trigger) || 'hover'
    // NOTE: 绑定事件
    if (trigger !== 'focus') {
      if (el.classList.contains('slider__handle')) {
        el.addEventListener('mousemove', e => {
          let ctor = binding.value.ctor
          ctor.onHandleTooltip(el, true)
        })
        el.addEventListener('mouseleave', e => {
          let ctor = binding.value.ctor
          ctor.onHandleTooltip(el, false)
        })
      } else {
        el.addEventListener('mouseenter', (e) => {
          let ctor = binding.value.ctor
          ctor.onHandleTooltip(el, true)
        })
        el.addEventListener('mouseleave', (e) => {
          let ctor = binding.value.ctor
          ctor.onHandleTooltip(el, false)
        })
      }
      // el.addEventListener('mouseenter', e => {
      //   let ctor = binding.value.ctor
      //   ctor.onHandleTooltip(el, true)
      // })
      // el.addEventListener('mouseleave', e => {
      //   let ctor = binding.value.ctor
      //   ctor.onHandleTooltip(el, false)
      // })
    } else {
      // NOTE: 不需要focus的问题
      el.addEventListener('focus', (e) => {
        let ctor = binding.value.ctor
        ctor.onHandleTooltip(el, true)
      })
      el.addEventListener('blur', (e) => {
        let ctor = binding.value.ctor
        ctor.onHandleTooltip(el, false)
      })
    }

    binding.value.ctor = ctor
  },
  inserted(el, binding) {
    let ctor = binding.value.ctor
    let options = ctor.options
    ctor.createTooltip(options, el)
  },
  update (el, binding) {
    binding.value = Object.assign(binding.oldValue, binding.value)
    let ctor = binding.value.ctor
    ctor.updateState(binding)
  },
  unbind (el, binding) {
    let ctor = binding.value.ctor
    ctor.destoryPopper()
  }
}



// WEBPACK FOOTER //
// ./src/module/tooltip/tooltip.js